import styles from './serviceProvisioning.module.css';



import React, { useState } from "react";
import { Formik, Form, Field, ErrorMessage, useField } from "formik";
import * as Yup from "yup";
import { Submit } from "../../../../components/button/buttons";
import IMAGES from "../../../../assets/images/images";
import FileUploadAttachment from "../../../../components/fileUpload/fileUpload.container"
import { useParams } from "react-router-dom";
import { DEMAND_ACTIONS } from "../../../../utils/constants/DemandConstant";
import Asterisk from '../../../../components/asterisk/Asterisk';
import { FormFieldLabel as Label, FormErrorLabel as ErrorLabel } from "../../../../components/label/Labels";
import { FieldWrapper } from '../../../../components/Section/Section';
import { FormTextArea } from '../../../../components/input/inputs';
import { TextField } from '../../controllers/quotationControllers';
import { connect } from 'react-redux';
import { addDemandAction } from '../../../../redux/actions/demand/demand.action';
import { openAlertPopup } from '../../../../redux/actions/Alert/alert.action';

const ImageUpload = ({ setFieldValue, value, label, feasibility, data, ...props }) => {
    const [field, meta, helpers] = useField(props);
    const hasError = meta.touched && meta.error ? true : false;
    return (
        <div >
            <div style={{ display: "flex" }}><Label text={label} optional={false} />  <Asterisk /></div>
            <FileUploadAttachment
                setFieldValue={setFieldValue}
                name={props.name}
                value={value}
                note={false}
                displayMessage={"Upload limit: 1 PDF file, up to 5 MB."}
                maxFileSize={5 * 1024 * 1024} //5MB
                maxFileSizeTXT={"5MB"}
                combineFilesMaxSize={5 * 1024 * 1024}
                combineFilesMaxSizeTXT={"Combined file size exceeds the 5MB limit"}
                numOfFilesAllowToUpload={1}
                errorMessageForNumberOfFiles={"You can upload max 1 files."}
                acceptFileType={{
                    'application/pdf': ['.pdf'],
                }}
            />
            {/* {hasError ? <ErrorLabel text={meta.error} /> : null} */}
        </div>
    );
};


const ServiceProvisioning = ({ handelServiceDetailapi, ...props }) => {
    const [isSubmit, setIsSubmit] = useState(false);
    let { requestId } = useParams();

    const validationSchema = Yup.object({
        comment: Yup.string().max(1000, "Comment must be at most 1000 characters"),
        files: Yup.array().min(1, "File is required"),
    });

    return (
        <>
            <div className={styles.container}>
                <header className={styles.demandheader}>
                    <div>Use this section to confirm 'Ready for Service (RFS)' by uploading the relevant document.</div>
                    <div>This will notify the Account Manager via email.</div>
                    {/* <img className={styles.circleinfo}src={IMAGES.infoCircle}alt="Information icon"/> */}
                </header>
                <Formik
                    initialValues={{comment:"", files: [] }}
                    validationSchema={validationSchema}
                    validateOnMount
                    onSubmit={async(values, helpers) => {
                        const { resetForm } = helpers;
                        setIsSubmit(true)
                        try {
                            const payload = {action:DEMAND_ACTIONS.COMPLETE_PROVISIONING,stateData: {...values}}
                            const res = await props?.addDemandAction(payload, requestId);
                            if (!res) {
                                props.openAlertPopup({
                                    message: "Unable to process. Please try again.",
                                    image: IMAGES.error,
                                });
                                return;
                            }
                            await handelServiceDetailapi();
                            props.openAlertPopup({
                                message: "RFS document uploaded successfully.",
                                image: IMAGES.success,
                            });
                            resetForm();
                        } catch (error){
                            props?.openAlertPopup({
                                message:"An error occurred while processing your request. Please try again later.",
                                image: IMAGES.error,
                        });
                        } finally {setIsSubmit(false);}
                    }}
                >
                    {({ isValid, dirty, isSubmitting, errors, touched, setFieldValue, values }) => {
                        return (
                            <Form noValidate className={styles.form}>
                                {/* <div className={styles.field}>
                                     <TextField
                                        label={"Comment"}
                                        id="description"
                                        name="comment"
                                        textLimit={`${values?.comment?.length ?? 0}/1000 characters`}
                                    />
                                </div> */}
                                <div className={styles.field}>
                                    <div className={styles.labelRow}>
                                        <div className={styles.label} id="remarks-label">
                                            Comment
                                        </div>
                                    </div>
                                    <Field
                                        as="textarea"
                                        name="comment"
                                        className={styles.textarea}
                                        rows={1}
                                        placeholder=""
                                    />
                                    <div className={styles.errorwrapper}>
                                        <div className={styles.errorRow}>
                                            <ErrorMessage name="comment">
                                                {(msg) => <div className={styles.error}>{msg}</div>}
                                            </ErrorMessage>
                                        </div>
                                        <div className={styles.commentValidation}>{`${values?.comment?.length}/1000 characters`}</div>
                                    </div>
                                </div>
                                <div className={styles.field}>
                                    <ImageUpload
                                        name="files"
                                        value={values.files}
                                        label="RFS Document"
                                        setFieldValue={setFieldValue}
                                        optional={false}
                                        shoInlineError={false}
                                        feasibility={values.feasibility}
                                        isUploadReport={true}
                                    />
                                </div>
                                {/* <div className={`${styles.moduledescription}`}> <img className={styles.descriptioncircle} src={IMAGES.actionIcon} />Ensure that you download order form and send it to GL Team For Signature via Email and then upload the Signed orderForm back on the Portal .</div> */}
                                <div className={styles.actions}>
                                    <Submit
                                        type="submit"
                                        disabled={isSubmitting || !(isValid && dirty)}
                                        style={styles.submit}
                                        isSubmitting={isSubmit}
                                        title={"Upload"}
                                    />
                                </div>
                            </Form>
                        );
                    }}
                </Formik>
            </div>
        </>
    );
};

const mapStateToProps = (state) => {
  return null;
};

const mapDispatchToProps = (dispatch) => {
  return {
    addDemandAction: (payload,id)=>{
      return dispatch(addDemandAction(payload,id))
    },
    openAlertPopup: (alertHeader,alertmessage) => {
      return dispatch(openAlertPopup(alertHeader,alertmessage))
    },
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(ServiceProvisioning);